import { defineStore } from 'pinia';

import { axios } from '@/helpers/axios';

export interface EtsyCircuitBreakerState {
  status: 'up' | 'down' | null;
}

export const useEtsyCircuitBreakerStore = defineStore('etsyCircuitBreaker', {
  state: () => ({
    status: null,
  }),
  actions: {
    setActions(data: EtsyCircuitBreakerState) {
      this.status = data.status;
    },
    async requestStatus() {
      return await axios.get<EtsyCircuitBreakerState>('/ping/etsy-api/status');
    },
  },
});